export interface LocationModel {
  id: number;
  name: string;
}

export interface GetLocationsRes {
  itemsCount: number;
  locations: LocationModel[];
}
